import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, Link as LinkIcon, FileText, LibraryBig, Images, Contact, Globe, DollarSign } from 'lucide-react';
import styles from './CSS/SuperadminSetting.module.css';

const SuperadminSettings = () => {
  const navigate = useNavigate();

  const settingsBlocks = [
    {
      title: 'Logo Settings',
      icon: <Image className={styles.blockIcon} />,
      path: '/admin/logo'
    },
    {
      title: 'Links Settings',
      icon: <LinkIcon className={styles.blockIcon} />,
      path: '/admin/links'
    },
    {
      title: 'Pages Settings',
      icon: <FileText className={styles.blockIcon} />,
      path: '/admin/pagessettings'
    },
    {
      title: 'Category Settings',
      icon: <LibraryBig className={styles.blockIcon} />,
      path: '/admin/all-categories'
    },
    {
      title: 'Hero Section Settings',
      icon: <Images className={styles.blockIcon} />,
      path: '/admin/hero-section'
    },
    {
      title: 'Contact Us Setting',
      icon: <Contact className={styles.blockIcon} />,
      path: '/admin/contact-us'
    },
    {
      title: 'SEO Setting',
      icon: <Globe className={styles.blockIcon} />,
      path: '/admin/seo-setting'
    },
    {
      title: 'Payment Plans',
      icon: <DollarSign className={styles.blockIcon} />,
      path: '/admin/payment-plans'
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Superadmin Settings</h1>
        <p className={styles.subtitle}>
          Manage your application settings and configurations
        </p>
      </div>

      <div className={styles.blocksContainer}>
        {settingsBlocks.map((block, index) => (
          <div 
            key={index} 
            className={styles.block}
            onClick={() => navigate(block.path)}
          >
            <div className={styles.iconWrapper}>
              {block.icon}
            </div>
            <h2 className={styles.blockTitle}>{block.title}</h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuperadminSettings;